var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 3V4H14.0055V3C14.0055 2.44772 13.5578 2 13.0055 2H9.00003C9.00003 0.89543 8.1046 0 7.00003 0C5.89546 0 5.00003 0.89543 5.00003 2H1.00195C0.449668 2 0.00195312 2.44772 0.00195312 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0475 15.0499L12.5 6H1.50003L1.95253 15.0499C1.97914 15.5821 2.41841 16 2.95128 16H11.0488C11.5817 16 12.0209 15.5821 12.0475 15.0499Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ca710a6905cc1b50b99454131b43920c.svg";
export { ForwardRef as ReactComponent };